import React, { useRef } from "react";
import styled from "styled-components";
import LandingSection from "../components/Home/LandingSection";
import WhySection from "../components/Home/WhySection";
import HowSection from "../components/Home/HowSection";
import WhatSection from "../components/Home/WhatSection";
import Contactez from "../components/Home/Contactez";
import { motion, useScroll } from "framer-motion";
import { useMediaQuery } from "react-responsive";

const Discover = () => {
  const ref = useRef(null);
  const isCpu = useMediaQuery({ maxWidth: 992 });
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["0", "0.95 1"],
  });

  return (
    <HomeWrapper ref={ref}>
      {isCpu ? (
        <ProgressLine style={{ scaleX: scrollYProgress }}></ProgressLine>
      ) : (
        <svg
          width="100%"
          height="360%"
          viewBox="0 0 1081 3979"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <motion.path
            id="p"
            d="M-68 0.5C3.5 190 -28 297.5 42 339.5C171.616 417.27 452.5 207.5 500 383C538.454 525.076 255 481 229 622.5C215.5 695.971 347 798 301 905.5C255 1013 155 947.5 105.5 1037C56 1126.5 205.5 1200 267 1296C333.723 1400.15 281.466 1438.27 486.5 1535C584 1581 930.5 1567 956.5 1692.5C982.5 1818 960 1865.5 910.5 1863.5C861 1861.5 857.5 1816 889 1814C920.5 1812 980.5 1812 956.5 1917.5C932.5 2023 1064 2198 1076 2292C1088 2386 1046.5 2429.5 1022.5 2443.5C998.5 2457.5 751 2583 554 2563C357 2543 378.5 2623.63 313 2688.5C261 2740 171 2697 103.5 2784.5C36 2872 -59.5 3053.5 58 3147C175.5 3240.5 309.5 3079 355 3232.5C400.5 3386 632 3627.5 616 3729C600 3830.5 271 4012 386.5 3970C478.9 3936.4 635 3956 701.5 3970"
            stroke="#F9CC0B"
            strokeWidth="5"
            pathLength="1"
            style={{ pathLength: scrollYProgress }}
          />
        </svg>
      )}
      <LandingSection />
      <WhySection />
      <HowSection />
      <WhatSection />
      <Contactez />
    </HomeWrapper>
  );
};

export default Discover;

const HomeWrapper = styled.section`
  svg {
    position: absolute;
    margin-top: 60vh;
    z-index: -5;
  }
`;

const ProgressLine = styled(motion.div)`
  position: fixed;
  height: 0.9vh;
  border-radius: 0.45vh;
  width: 100%;
  background: #f9cc0b;
  z-index: 11;
  @media (max-width: 1024px) {
    height: 0.4vh;
  }
`;
